import { ACTION_SUBJECT_PREFIX } from '../../constants/analytics';
import { type ProductKeys, is3pProductKey } from '../../constants/product-keys';
import { type FireAnalyticsEvent } from '../../types';
import { type CommonAttributes, type NonPrivacySafeAttributes } from './types';

// eslint-disable-next-line no-barrel-files/no-barrel-files
export { onAppFilterShowMoreHovered } from './on-app-filter-show-more-hovered';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { onAppFilterShowMoreClicked } from './on-app-filter-show-more-clicked';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { onAppFilterRendered } from './on-app-filter-rendered';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { onRightPanelFeedbackClicked } from './on-right-panel-feedback-clicked';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { onRightPanelFeedbackModalCloseClicked } from './on-right-panel-feedback-modal-close-clicked';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { onAppFilterShowMoreTextFieldFocused } from './on-app-filter-show-more-text-field-focused';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { onRightPanelFeedbackSubmitClicked } from './on-right-panel-feedback-submit-clicked';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { onRightPanelFeedbackCancelClicked } from './on-right-panel-feedback-cancel-clicked';

type RightPanelAppFilterBaseArgs = {
	commonAttributes: CommonAttributes;
	nonPrivacySafeAttributes: NonPrivacySafeAttributes;
	productKey: ProductKeys | undefined;
	isConnected: boolean;
};

type RightPanelAppFilterHoveredArgs = RightPanelAppFilterBaseArgs & {
	index?: number;
	isInShowMore?: boolean;
};

/** button hovered searchPageRightPanelAppFilter */
export const onAppFilterOptionHovered = ({
	commonAttributes,
	nonPrivacySafeAttributes,
	productKey,
	isConnected,
	index,
	isInShowMore,
}: RightPanelAppFilterHoveredArgs): FireAnalyticsEvent => ({
	eventType: 'ui',
	actionSubject: 'button',
	actionSubjectId: `${ACTION_SUBJECT_PREFIX}RightPanelAppFilter`,
	action: 'hovered',
	attributes: {
		additionalAttributes: {
			productKey: productKey ?? 'all',
			is3pProduct: productKey ? is3pProductKey(productKey) : false,
			isConnected,
			...(index !== undefined && { index }),
			...(isInShowMore !== undefined && { isInShowMore }),
		},
		commonAttributes,
	},
	nonPrivacySafeAttributes,
});

/** button hovered searchPageRightPanelAppFilterMenuButton */
export const onAppFilterMenuButtonHovered = ({
	commonAttributes,
	nonPrivacySafeAttributes,
	productKey,
	isConnected,
}: RightPanelAppFilterBaseArgs): FireAnalyticsEvent => ({
	eventType: 'ui',
	actionSubject: 'button',
	actionSubjectId: `${ACTION_SUBJECT_PREFIX}RightPanelAppFilterMenuButton`,
	action: 'hovered',
	attributes: {
		additionalAttributes: {
			productKey: productKey ?? 'all',
			is3pProduct: productKey ? is3pProductKey(productKey) : false,
			isConnected,
		},
		commonAttributes,
	},
	nonPrivacySafeAttributes,
});

/** button clicked searchPageRightPanelAppFilterHideButton */
export const onAppFilterHideButtonClicked = ({
	commonAttributes,
	nonPrivacySafeAttributes,
	productKey,
	isConnected,
}: RightPanelAppFilterBaseArgs): FireAnalyticsEvent => ({
	eventType: 'ui',
	actionSubject: 'button',
	actionSubjectId: `${ACTION_SUBJECT_PREFIX}RightPanelAppFilterHideButton`,
	action: 'clicked',
	attributes: {
		additionalAttributes: {
			productKey: productKey ?? 'all',
			is3pProduct: productKey ? is3pProductKey(productKey) : false,
			isConnected,
		},
		commonAttributes,
	},
	nonPrivacySafeAttributes,
});

/** button hovered searchPageRightPanelAppFilterHideButton */
export const onAppFilterHideButtonHovered = ({
	commonAttributes,
	nonPrivacySafeAttributes,
	productKey,
	isConnected,
}: RightPanelAppFilterBaseArgs): FireAnalyticsEvent => ({
	eventType: 'ui',
	actionSubject: 'button',
	actionSubjectId: `${ACTION_SUBJECT_PREFIX}RightPanelAppFilterHideButton`,
	action: 'hovered',
	attributes: {
		additionalAttributes: {
			productKey: productKey ?? 'all',
			is3pProduct: productKey ? is3pProductKey(productKey) : false,
			isConnected,
		},
		commonAttributes,
	},
	nonPrivacySafeAttributes,
});
